import React from 'react';
import { Tables } from '@deeptrue-frontend/ui';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveModal from 'components/PromptModal/PromptModal';
import { useFormatMessage } from 'components/IntlProvider';

const { TableRow, TableCell } = Tables;

interface Props {
  name: string;
  id: number;
  removeGroupFromProject: (id: number) => void;
}

const Group = ({ name, id, removeGroupFromProject }: Props) => {
  const t = useFormatMessage();
  return (
    <TableRow>
      <TableCell minWidth="150px" height="2rem" padding="0.5rem">
        {name}
      </TableCell>

      <TableCell height="2rem" padding="0.5rem" width="80px" align="right">
        <Tooltip title={t('organization.unshare', 'Unshare')}>
          <span style={{ cursor: 'pointer' }}>
            <RemoveModal
              onConfirm={() => removeGroupFromProject(id)}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              <span style={{ textAlign: 'left' }}>
                {t(
                  'organization.confirmDelete',
                  'Are you sure you want to remove {x} from {y}',
                  {
                    x: name,
                    y: t('organization.project', 'project'),
                  }
                )}
              </span>
            </RemoveModal>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default Group;
